import React, { useEffect, useState } from 'react'
import MobileNav from '../../component/MobileNav';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getEkycResponse, initiateEkyc } from '../../Utils/api';
import JourneyRightPanel from '../../component/JourneyRightPannel';
import { updateJourneyEvents } from '../../CustomerJourneyDetails/CustomerJourneyDetails';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');

  .ekyc-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .ekyc-page {
    min-height: 100vh;
    background: #eaf1fd;
    display: flex;
    flex-direction: column;
    font-family: 'Sora', sans-serif;
  }

  .ekyc-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex: 1;
    min-height: calc(100vh - 60px);
    margin-top: 50px;
  }

  /* ── LEFT ── */
  .ekyc-left {
    display: flex;
    flex-direction: column;
    padding: 3rem 3.5rem;
    background: #eaf1fd;
    overflow-y: auto;
  }

  .ekyc-logo {
    display: flex; align-items: center; gap: 10px;
    margin-bottom: 2.5rem;
  }
  .ekyc-logo-dot {
    width: 34px; height: 34px; background: #F97316;
    border-radius: 10px; display: flex; align-items: center; justify-content: center;
  }
  .ekyc-logo-dot svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2.2; stroke-linecap: round; }
  .ekyc-logo-name { font-size: 16px; font-weight: 600; color: #0f1c2e; letter-spacing: -0.2px; }

  .ekyc-card {
    background: #fff;
    border-radius: 24px;
    padding: 2.25rem 2.5rem;
    box-shadow: 0 4px 40px rgba(15,28,46,0.08), 0 1px 4px rgba(15,28,46,0.04);
    border: 1px solid rgba(255,255,255,0.8);
  }

  /* badge */
  .ekyc-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(249,115,22,0.08);
    border: 1px solid rgba(249,115,22,0.25);
    border-radius: 20px; padding: 5px 13px;
    color: #F97316; font-size: 12px; font-weight: 600;
    margin-bottom: 1.25rem;
  }
  .ekyc-badge svg { width: 13px; height: 13px; }

  .ekyc-card-title {
    font-size: 22px; font-weight: 700;
    color: #0f1c2e; letter-spacing: -0.5px; margin-bottom: 6px;
  }
  .ekyc-card-sub {
    font-size: 13.5px; color: #6b7a90; line-height: 1.65; margin-bottom: 0.75rem;
  }

  /* AADHAAR HIGHLIGHT BOX */
  .ekyc-highlight {
    display: flex; align-items: flex-start; gap: 12px;
    background: rgba(55,138,221,0.07);
    border: 1px solid rgba(55,138,221,0.18);
    border-radius: 14px; padding: 14px 16px;
    margin-bottom: 1.75rem;
  }
  .ekyc-highlight-icon {
    width: 36px; height: 36px; border-radius: 9px;
    background: rgba(55,138,221,0.14);
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .ekyc-highlight-icon svg { width: 18px; height: 18px; fill: none; stroke: #378ADD; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
  .ekyc-highlight-text { font-size: 13px; color: #2c4a6e; font-weight: 500; line-height: 1.5; }
  .ekyc-highlight-text span { font-weight: 400; color: #5a7a9b; font-size: 12px; display: block; margin-top: 2px; }

  /* SECTION */
  .ekyc-section-title {
    font-size: 11px; font-weight: 600; letter-spacing: 0.7px;
    text-transform: uppercase; color: #9aaabb;
    margin-bottom: 1rem;
    display: flex; align-items: center; gap: 8px;
  }
  .ekyc-section-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }

  /* STEPS LIST */
  .ekyc-steps { display: flex; flex-direction: column; gap: 10px; margin-bottom: 1.75rem; }
  .ekyc-step {
    display: flex; align-items: center; gap: 14px;
    padding: 13px 16px;
    background: #f7f9fc;
    border: 1px solid #e8eef7;
    border-radius: 14px;
    transition: border-color 0.15s, background 0.15s;
  }
  .ekyc-step:hover { background: #fff; border-color: #d0dff0; }
  .ekyc-step-num {
    width: 28px; height: 28px; border-radius: 8px;
    background: #0f1c2e;
    color: #fff; font-size: 12px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .ekyc-step-text { font-size: 13px; color: #2d3748; font-weight: 500; }
  .ekyc-step-icon {
    margin-left: auto; flex-shrink: 0;
    width: 28px; height: 28px; border-radius: 8px;
    background: rgba(52,211,153,0.12);
    display: flex; align-items: center; justify-content: center;
  }
  .ekyc-step-icon svg { width: 14px; height: 14px; fill: none; stroke: #34d399; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }

  /* CTA */
  .ekyc-cta {
    width: 100%; height: 50px;
    border: none; border-radius: 14px;
    background: #F97316; color: #fff;
    font-family: 'Sora', sans-serif;
    font-size: 15px; font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 9px;
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
    letter-spacing: -0.1px;
  }
  .ekyc-cta:hover:not(:disabled) {
    background: #ea6a0a;
    box-shadow: 0 6px 24px rgba(249,115,22,0.42);
    transform: translateY(-1px);
  }
  .ekyc-cta:active:not(:disabled) { transform: scale(0.98); }
  .ekyc-cta:disabled { background: #c8d3e2; box-shadow: none; cursor: not-allowed; }
  .ekyc-cta svg { width: 17px; height: 17px; }

  /* TRUST */
  .ekyc-trust {
    display: flex; align-items: center; justify-content: center;
    gap: 6px; margin-top: 1.25rem;
    font-size: 11.5px; color: #9aaabb;
  }
  .ekyc-trust svg { width: 13px; height: 13px; }
  .ekyc-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .ekyc-split { grid-template-columns: 1fr; }
    .ekyc-left { padding: 2rem 1.25rem 6rem; }
    .ekyc-logo { margin-bottom: 1.5rem; }
    .ekyc-card { padding: 1.75rem 1.5rem; }
  }
  @media (max-width: 400px) {
    .ekyc-card { padding: 1.5rem 1.25rem; }
  }
`;

const IconBolt = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);
const IconShieldCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2"/>
    <line x1="12" y1="18" x2="12.01" y2="18"/>
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
);
const IconSend = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);
const IconStar = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

const STEPS = [
  'Enter your Aadhaar / PAN details',
  'Verify using OTP sent to your mobile',
  'Details are verified instantly',
  'Loan application moves forward for approval',
];

export default function Ekyc() {
  const [loader, setLoader] = useState(false);
  const [aadhaar, setAadhaar] = useState(Array(12).fill(''));
  const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
  const dispatch = useDispatch();
  const utm_source = customerDetails?.utm_source;
  const utm_campaign = customerDetails?.utm_campaign;


  useEffect(() => {
  const last4 = customerDetails?.aadhar_no;
 

  if (last4 && last4.length === 4) {
    const arr = Array(12).fill('');

    // fill only last 4 digits
    for (let i = 0; i < 4; i++) {
      arr[8 + i] = last4[i];
    }

    setAadhaar(arr);
  }
}, [customerDetails]);



const handleKeyDown = (e, index) => {
  // Lock first 8 digits completely
  if (index < 8) {
    e.preventDefault();
    return;
  }

  // Handle Backspace
  if (e.key === 'Backspace') {
    e.preventDefault();

    const updated = [...aadhaar];

    // If current box has value -> clear it
    if (updated[index]) {
      updated[index] = '';
      setAadhaar(updated);
      return;
    }

    // Move only within last 4 digits
    if (index > 8) {
      updated[index - 1] = '';
      setAadhaar(updated);

      document.getElementById(`aadhaar-${index - 1}`)?.focus();
    }

    return;
  }

  // Allow tab and arrow navigation
  if (['Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
    return;
  }

  // Allow only numeric digits
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
  }
};

const handleChange = (value, index) => {
  // Prevent editing first 8 digits
  if (index < 8) return;

  // Allow only single digit
  if (!/^\d?$/.test(value)) return;

  const updated = [...aadhaar];
  updated[index] = value;
  setAadhaar(updated);

  // Move to next input automatically
  if (value && index < 11) {
    document.getElementById(`aadhaar-${index + 1}`)?.focus();
  }
};
const leadId =  customerDetails?.lead_id;

useEffect(() => {
  const handleEkyc = async () => {
    const param={lead_id:leadId}

      if (leadId) {
        try {
          const ekycResponse = await getEkycResponse(param);

          if (ekycResponse?.data?.Status === 1) {
            if(utm_source == 'digitar_media') {
              const url = `https://lendingleaf.in/pb/pl?clickId=${utm_campaign}&event=kyc_complete`;
              fetch(url).catch(() => {});
            }

            dispatch(updateJourneyEvents({
              personal_details: 2,
              ekyc_detail: 1
            }));

          }
        } catch (error) {
          console.error("Error fetching eKYC response:", error);
        }
      }
    
  };

  handleEkyc();
}, [ leadId,dispatch]);


 const submit = async () => {
  const aadhaarNumber = aadhaar.join('');

  // validate last 4 digits
  const last4 = aadhaar.slice(8).join('');

  if (!/^\d{4}$/.test(last4)) {
    toast.error('Enter correct last 4 digit Aadhaar number');
    return;
  }

  setLoader(true);

  const param = {
    profileId: customerDetails?.profileId,
    aadhaar_no: aadhaarNumber
  };

  try {
    const response = await initiateEkyc(param);

    if (response?.data?.apiStatus == 1) {
      toast.success('Verification process started');
      window.location.href = response?.data?.data?.ekyc_url;
    } else {
      toast.error('Failed to start verification process');
    }
  } catch {
    toast.error('Failed to start verification process');
  } finally {
    setLoader(false);
  }
};

  return (
    <>
      <style>{styles}</style>
      <div className="ekyc-page">
        <div className="ekyc-split">

          {/* ── LEFT: FORM ── */}
          <div className="ekyc-left">
            

            <div className="ekyc-card">

              <div className="ekyc-badge">
                <IconStar />
                Paperless verification
              </div>

              <h1 className="ekyc-card-title">E-KYC verification</h1>
              <p className="ekyc-card-sub">
                Verify your last 4 digit of Aadhaar Number
              </p>

              {/* Aadhaar highlight */}

              <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
              {aadhaar.map((digit, index) => {
                const isEditable = index >= 8;

                return (
                  <input
                    key={index}
                    id={`aadhaar-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    readOnly={!isEditable}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    style={{
                      width: '25px',
                      height: '44px',
                      textAlign: 'center',
                      fontSize: '16px',
                      borderRadius: '8px',
                      border: '1px solid #e2e8f0',
                      outline: 'none',
                      background: isEditable ? '#fff' : '#f3f6fb',
                      color: isEditable ? '#000' : '#94a3b8',
                      cursor: isEditable ? 'text' : 'not-allowed',
                      fontWeight: 600
                    }}
                  />
                );
              })}
            </div>
             

              {/* Steps */}
              <div className="ekyc-section-title">How it works</div>
              <div className="ekyc-steps">
                {STEPS.map((step, i) => (
                  <div className="ekyc-step" key={i}>
                    <div className="ekyc-step-num">{i + 1}</div>
                    <span className="ekyc-step-text">{step}</span>
                    <div className="ekyc-step-icon"><IconCheck /></div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <button className="ekyc-cta" onClick={submit} disabled={loader}>
                {loader ? (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
                      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
                      </path>
                    </svg>
                    Starting e-KYC…
                  </>
                ) : (
                  <>Start e-KYC verification <IconSend /></>
                )}
              </button>

              <div className="ekyc-trust">
                <IconLock />
                256-bit SSL encrypted
                <span className="ekyc-trust-sep" />
                Your data is private
                <span className="ekyc-trust-sep" />
                RBI compliant
              </div>

            </div>
          </div>

          {/* ── RIGHT: reusable component ── */}
          <JourneyRightPanel />

        </div>
      </div>
      <MobileNav />
    </>
  );
}